/** Keys 1–4 (top row or numpad) → emote id 0–3 (GAME_PLAN §2.10, 4 per character). */
const EMOTE_KEYS: Readonly<Record<string, number>> = {
  Digit1: 0,
  Digit2: 1,
  Digit3: 2,
  Digit4: 3,
  Numpad1: 0,
  Numpad2: 1,
  Numpad3: 2,
  Numpad4: 3,
}

/** Placeholder bubble text until emote art exists (Phase 3). */
export const EMOTE_LABELS: readonly string[] = ['Hi!', 'GG', 'Wow!', 'Oops']

/** How long a bubble stays up. */
export const EMOTE_SHOW_MS = 1500

/** The emote id for a key press, or null for any other key. */
export function emoteForKey(code: string): number | null {
  return EMOTE_KEYS[code] ?? null
}

export function emoteLabel(id: number): string {
  return EMOTE_LABELS[id] ?? '!'
}
